module.exports = __webpack_public_path__ + "img/b.82791aa7.jpg";